module.exports = "<div [ngClass]=\"appearance\" class=\"select-date-input-wrapper\" tabindex=\"1\">\n  <input #dateInputElement (ngModelChange)=\"dateChanged($event)\" [(ngModel)]=\"date\" [ngClass]=\"{'all-dates': !date}\"\n         class=\"custom-date-input-style\" id=\"date_input\" name=\"date_input\" type=\"date\">\n  <label for=\"date_input\">\n    <div (click)=\"clickOnAllDates()\" *ngIf=\"!date && appearance !== 'fromTo' && appearance !== 'thin'\" class=\"all-dates-indicator\">כל התאריכים</div>\n  </label>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form/select-date/select-date.component.html
// module id = ./src/app/form/select-date/select-date.component.html
// module chunks = main